<template>
  <v-card
    :loading="loading"
    outlined
    :class="`flexcard ${isSelectedAddress ? 'selected_card' : ''}`"
    :color="isSelectedAddress ? 'success' : ''"
  >
    <template slot="progress">
      <v-progress-linear color="blue darken-2" indeterminate />
    </template>

    <v-card-subtitle class="text-right pb-0">
      <v-chip
        v-if="isSelectedAddress"
        outlined
        class="ma-2"
        color="success"
        label
        :disabled="loading"
      >
        <v-icon left>check</v-icon>Active Address
      </v-chip>
      <v-chip
        v-else
        outlined
        class="ma-2"
        color="blue darken-2"
        label
        @click="selectAddress()"
        :disabled="loading"
      >
        <v-icon left>add</v-icon>Set Active
      </v-chip>
    </v-card-subtitle>

    <v-list-item v-if="this.data">
      <v-list-item-content>
        <v-list-item-subtitle class="address_line subtitle font-weight-medium">
          {{ this.data.name }}
        </v-list-item-subtitle>

        <v-list-item-subtitle class="address_line subtitle font-weight-medium">
          {{ this.data.address_line_1 }}
        </v-list-item-subtitle>

        <v-list-item-subtitle class="address_line subtitle font-weight-medium">
          {{ this.data.address_line_2 }}
        </v-list-item-subtitle>

        <v-list-item-subtitle class="address_line subtitle font-weight-medium">
          {{ this.data.address_line_3 }}
        </v-list-item-subtitle>

        <v-list-item-subtitle class="address_line subtitle font-weight-medium">
          {{ this.data.address_line_4 }}
        </v-list-item-subtitle>

        <v-list-item-subtitle class="address_line subtitle font-weight-medium">
          {{ this.data.postcode }}
        </v-list-item-subtitle>

        <v-list-item-subtitle class="address_line subtitle font-weight-medium">
          {{ this.data.telephone }}
        </v-list-item-subtitle>

        <v-list-item-subtitle class="address_line subtitle font-weight-medium">
          {{ this.data.order_email }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-spacer></v-spacer>
    <v-card-actions class="dialogActions">
      <v-btn
        text
        color="deep-purple base"
        :disabled="loading"
        :to="{
          name: 'DeliveryAddressForm',
          params: { isNew: false, data: data },
        }"
        >Edit</v-btn
      >
      <v-spacer />
      <v-btn
        v-if="!isSelectedAddress"
        text
        color="error"
        @click="deleteAddressDialog = true"
        :disabled="loading"
      >
        Delete
      </v-btn>
    </v-card-actions>

    <v-dialog v-model="deleteAddressDialog" persistent max-width="400px">
      <v-card>
        <v-card-title>
          <h4>Delete Address</h4>
          <v-spacer></v-spacer>
          <v-btn icon color text @click="deleteAddressDialog = false">
            <v-icon>mdi-window-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-list-item v-if="this.data">
            <v-list-item-content>
              <v-list-item-subtitle
                class="address_line subtitle font-weight-medium"
              >
                {{ this.data.address_line_1 }}
              </v-list-item-subtitle>

              <v-list-item-subtitle
                class="address_line subtitle font-weight-medium"
              >
                {{ this.data.address_line_2 }}
              </v-list-item-subtitle>

              <v-list-item-subtitle
                class="address_line subtitle font-weight-medium"
              >
                {{ this.data.address_line_3 }}
              </v-list-item-subtitle>

              <v-list-item-subtitle
                class="address_line subtitle font-weight-medium"
              >
                {{ this.data.address_line_4 }}
              </v-list-item-subtitle>

              <v-list-item-subtitle
                class="address_line subtitle font-weight-medium"
              >
                {{ this.data.postcode }}
              </v-list-item-subtitle>

              <v-list-item-subtitle
                class="address_line subtitle font-weight-medium"
              >
                {{ this.data.telephone }}
              </v-list-item-subtitle>

              <v-list-item-subtitle
                class="address_line subtitle font-weight-medium"
              >
                {{ this.data.order_email }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card-text>
        <v-card-actions class="dialogActions">
          <v-btn :loading="loading" text @click="deleteAddressDialog = false"
            >Cancel</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn :loading="loading" color="error" @click="deleteAddress()">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    data: Object,
  },

  data() {
    return {
      loading: false,
      deleteAddressDialog: false,
    };
  },

  computed: {
    isSelectedAddress() {
      if (this.$store.getters.retrieveSelectedAddress) {
        return this.data.id == this.$store.getters.retrieveSelectedAddress.id;
      } else {
        return false;
      }
    },
  },

  methods: {
    ...mapActions([
      "getUserDeliveryAddresses",
      "deleteDeliveryAddress",
      "selectUserDeliveryAddress",
    ]),

    async selectAddress() {
      this.loading = true;
      let response = await this.selectUserDeliveryAddress(this.data.id);
      this.loading = false;

      console.log("-- Select Address Params Check");
      console.log(this.$route.params);
      console.log(response);
      if (response) {
        if (this.$route.params.onSelectBack == true) {
          this.$router.go(-1);
        }
      }
    },

    async deleteAddress() {
      this.loading = true;
      await this.deleteDeliveryAddress(this.data.id);
      await this.getUserDeliveryAddresses();
      this.deleteAddressDialog = false;
      this.loading = false;
    },
  },
};
</script>

<style lang="sass" scoped>
.address_line
  height: 20px

.selected_card
  color: var(--v-color-base) !important
  background-color: var(--v-background-base) !important
  border-color: var(--v-success-base) !important

.flexcard
  display: flex
  flex-direction: column
  height: 100%

  & .v-toolbar
    flex: 0
</style>